import React from "react"
import { usePagesContent } from "shared/Hooks/PagesContent"
import SEO from "components/seo"

const Page = ({ pageContext: { id } }) => {
  const data = usePagesContent()[id]
  return (
    <>
      <SEO title={data.seoTitle} description={data.seoDescription} />
      {data.jsx}
    </>
  )
}

export default Page
